import {StatusManager} from "../StatusManager";
import {MutableCompany} from "../MutableCompany";
import {MutableSyncCycle} from "./MutableSyncCycle";
import {TCrudMode} from ".";
import detailsHtml from './details.html?raw';

export const template = detailsHtml

export class viewModel {

    private readonly mutableCompany: MutableCompany
    private readonly mutableSyncCycle: MutableSyncCycle

    constructor(private statusManager: StatusManager) {
        this.mutableCompany = statusManager.mutableCompany
        this.mutableSyncCycle = statusManager.mutableSyncCycle
        this.mutableSyncCycle.crudMode('read')
    }

    private isContentMode(mode: TCrudMode) {
        return this.mutableSyncCycle.crudMode() == mode
    }

}